import { make } from 'vuex-pathify'

const modulesFiles = require.context('@/json', true, /\.json$/)
const data = modulesFiles.keys().reduce((data, modulePath) => {
  const keyName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1').replace('./', '')
  data[keyName] = modulesFiles(modulePath)
  return data
}, {})

const state = {
  ...data
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  getters
}
